<div fxLayout>
  <main fxFlex [ngClass.lt-md]="{ mobile: true }" class="subnav__exists" fxLayout="column" fxLayoutGap="24px">
    <ng-container *ngIf="pageLoadingState === LoadingState.Pending">
      <mat-spinner [diameter]="32"></mat-spinner>
    </ng-container>

    <ng-container *ngIf="pageLoadingState === LoadingState.Success">
      <ng-container *ngIf="agreement">
        <sbnb-back-button [label]="'Back'" [routerLink]="['/gx/rental-agreements']"></sbnb-back-button>

        <section id="header">
          <div fxLayout fxFlex fxLayoutGap="12px">
            <mat-slide-toggle [(ngModel)]="agreement.is_active" (change)="editModeContentUpdated()" />

            <h2 class="input__editable nomargin" fxFlex>
              <span
                #nameSpan
                style="padding-left: 0; padding-right: 8px; visibility: hidden; position: absolute; left: -9999px">
                {{ agreement.name }}
              </span>

              <input
                class="input__borderless"
                type="text"
                [style.width.px]="nameSpan.getBoundingClientRect().width"
                [(ngModel)]="agreement.name"
                (change)="editModeContentUpdated()" />
            </h2>
          </div>

          <sbnb-button
            *ngIf="!recentlySaved && mode === 'new'"
            size="mini"
            [loading]="saving"
            (clicked)="saveChanges()">
            Save
          </sbnb-button>

          <div *ngIf="recentlySaved" fxLayout fxLayoutAlign="center center" fxLayoutGap="4px">
            <mat-icon class="grass-darker">check</mat-icon>
            <span class="grass-darker">Saved</span>
          </div>
        </section>

        <section id="content">
          <section id="scoping">
            <div class="section-heading" fxLayout="column" fxLayoutGap="24px" fxLayoutAlign="start">
              <div fxLayout fxLayoutAlign="start center" fxLayoutGap="12px">
                <img
                  class="document-icon"
                  src="/assets/iconography/office-sign-document.svg"
                  width="20px"
                  height="20px"
                  onload="SVGInject(this)" />
                <h3 class="flex grow">Document</h3>
                <div class="flex flex-end">
                  <sbnb-button size="mini" type="secondary" (clicked)="openPreviewDialog()">Preview</sbnb-button>
                </div>
              </div>

              <div class="section-content">
                <div
                  class="default-container"
                  fxLayout
                  fxLayoutAlign="start center"
                  fxLayoutGap="24px"
                  *ngIf="combinedCodes">
                  <sbnb-rich-text-editor
                    [content]="agreement.content"
                    [placeholderExtension]="PlaceholderExtension"
                    [placeholderContent]="placeholderContent"
                    [tributeValues]="combinedCodes"
                    (contentUpdated)="onContentUpdated($event)"
                    style="width: 100%"></sbnb-rich-text-editor>
                </div>

                <!-- Show a warning if we have any confirmation rulesets missing guest portal shortcodes -->
                <sbnb-alert-card
                  *ngIf="confirmation_rulesets_missing_guestportal_shortcode?.length > 0"
                  context="warning"
                  class="flex flex-col gap-1">
                  <div class="flex items-center gap-2">
                    <sbnb-icon icon="alert-triangle" class="text-rose-darker shrink-0"></sbnb-icon>
                    <h3>Some confirmation messaging rules are missing guest portal shortcodes.</h3>
                  </div>

                  <div class="mt-2">
                    <div>
                      Guests are much more likely to sign an agreement if they receive instructions in their booking
                      confirmation message.
                    </div>

                    <div class="mt-4">These messaging rules are missing guest portal shortcodes:</div>

                    <ul class="gap-2 flex flex-col">
                      <a
                        *ngFor="let rule of confirmation_rulesets_missing_guestportal_shortcode"
                        class="link-emphasized"
                        [routerLink]="['/gx/rule', rule.id]">
                        <li>{{ rule.name }}</li>
                      </a>
                    </ul>
                  </div>
                </sbnb-alert-card>
              </div>
            </div>
          </section>

          <section id="conditions">
            <div class="section-heading" fxLayout fxLayoutGap="24px" fxLayoutAlign="start center">
              <div fxLayout fxLayoutAlign="start center" fxLayoutGap="12px">
                <sbnb-icon icon="time" class="shrink-0 text-smoke-darker"></sbnb-icon>
                <h3>Condition</h3>
                <div>
                  <ng-container *ngIf="agreement.min_number_of_nights !== null; else defaultCondition">
                    the booking is for min
                    <button
                      mat-flat-button
                      class="filter__option-btn button__small button__text"
                      [matMenuTriggerFor]="minNumberNightsMenu">
                      <span>
                        {{ agreement.min_number_of_nights }}
                      </span>
                    </button>
                    {{ 'nights' | pluralize: agreement.min_number_of_nights }}

                    <mat-menu #minNumberNightsMenu="matMenu" class="filters__cdk-menu">
                      <div fxLayout="column" class="filters__input-number-rg">
                        <mat-form-field (click)="$event.stopPropagation()">
                          <input
                            matInput
                            type="number"
                            [(ngModel)]="agreement.min_number_of_nights"
                            (change)="editModeContentUpdated()" />
                        </mat-form-field>

                        <button class="filter__btn-done">Done</button>
                      </div>
                    </mat-menu>

                    and max
                    <button
                      mat-flat-button
                      class="filter__option-btn button__small button__text"
                      [matMenuTriggerFor]="maxNumberNightsMenu">
                      <span *ngIf="agreement.max_number_of_nights !== null">
                        {{ agreement.max_number_of_nights }}
                      </span>
                      <span *ngIf="agreement.max_number_of_nights === null">[ select ]</span>
                    </button>

                    {{ 'nights' | pluralize: agreement.max_number_of_nights }}

                    <mat-menu #maxNumberNightsMenu="matMenu" class="filters__cdk-menu">
                      <div fxLayout="column" class="filters__input-number-rg">
                        <mat-form-field (click)="$event.stopPropagation()">
                          <input
                            matInput
                            type="number"
                            [(ngModel)]="agreement.max_number_of_nights"
                            (change)="editModeContentUpdated()" />
                        </mat-form-field>

                        <button class="filter__btn-done">Done</button>
                      </div>
                    </mat-menu>

                    <button
                      mat-flat-button
                      class="button__small button__text remove__button"
                      (click)="
                        agreement.min_number_of_nights = null;
                        agreement.max_number_of_nights = null;
                        editModeContentUpdated()
                      ">
                      Remove condition
                    </button>
                  </ng-container>

                  <ng-template #defaultCondition>
                    this agreement will show for all bookings

                    <button
                      mat-flat-button
                      class="filter__option-btn button__small button__text"
                      (click)="agreement.min_number_of_nights = 0">
                      + Add a condition
                    </button>
                  </ng-template>
                </div>
              </div>
            </div>
          </section>

          <section id="scoping">
            <div class="section-heading" fxLayout fxLayoutGap="24px" fxLayoutAlign="start center">
              <div fxLayout fxLayoutAlign="start center" fxLayoutGap="12px">
                <sbnb-icon icon="scope" class="text-smoke-darker"></sbnb-icon>
                <h3>Scope</h3>
              </div>
            </div>

            <div class="section-content">
              <div class="platforms-section mb-4">
                <div fxLayout fxLayoutAlign="space-between center" fxLayoutGap="8px" class="rule__scope-header">
                  <h4>Platforms</h4>
                </div>
                <ng-container *ngFor="let platform of possiblePlatforms">
                  <div class="flex flex-col">
                    <mat-checkbox
                      [checked]="agreement && agreement.platforms && agreement.platforms.indexOf(platform.key) > -1"
                      (change)="platformsCheckboxChange(platform, $event)">
                      <span fxLayout fxLayoutGap="8px" fxLayoutAlign="start center">
                        <div class="host__img">
                          <img [src]="'/assets/iconography/' + platform.key + '.svg'" />
                        </div>

                        <span fxFlex>{{ platform.label }}</span>
                      </span>
                    </mat-checkbox>
                  </div>
                </ng-container>
              </div>

              <sbnb-property-selection
                [selectedProperties]="agreement.property_ids"
                [allPropertiesEnabled]="false"
                [border]="true"
                [listHeight]="280"
                (propertiesChange)="editModeContentUpdated()"></sbnb-property-selection>
            </div>
          </section>

          <div fxflex fxLayout class="actions">
            <sbnb-button
              *ngIf="mode === 'edit'"
              class="delete"
              label="Delete"
              icon="delete"
              type="text"
              size="mini"
              [labelColor]="'#ED3C6A'"
              (clicked)="deleteAgreement()"></sbnb-button>
          </div>
        </section>
      </ng-container>

      <ng-container *ngIf="!agreement">
        <sbnb-no-items text="We could not find the reservation agreement you requested"></sbnb-no-items>
      </ng-container>
    </ng-container>
  </main>
</div>

<sbnb-mobile-sidebar [navTabsHide]="true" [title]="'Guest Experience'">
  <sbnb-gx-subnav></sbnb-gx-subnav>
</sbnb-mobile-sidebar>

<!-- <mat-menu #conditionsMenu="matMenu" class="filters__cdk-menu condition__menu filter__list-fixed-height">
  <input #searchInput class="filters__input-list-search" [(ngModel)]="searchCriteria" type="text" placeholder="Search"
    (click)="$event.stopPropagation()" />

  <ng-container *ngFor="let condition of allConditionsArray; ">
    <button *ngIf="
        !searchCriteria ||
        searchCriteria === '' ||
        condition.label_before.indexOf(searchCriteria) > -1 ||
        condition.label_after.indexOf(searchCriteria) > -1
      " mat-menu-item (click)="addCondition(condition)">
      <span [class.strong]="condition.label_importance === 'before'">{{ condition.label_before }}</span>
      <span *ngIf="condition.type === 'int'">...</span>
      <ng-container *ngIf="condition.type === 'boolean' && condition.bool_true && condition.bool_false">
        <span>&nbsp;{{ condition.bool_true }} / {{ condition.bool_false }}&nbsp;</span>
      </ng-container>
      <span [class.strong]="condition.label_importance === 'after'">{{ condition.label_after }}</span>
    </button>
  </ng-container>
</mat-menu> -->
